import HowImarikaChamaa from "./HowImarikaChamaa";
import WhoImarikaChamaa from "./WhoImarikaChamaa";
import WhyImarikaChamaa from "./WhyImarikaChamaa";

const posts = [
  {
    id: 1,
    title: "How does Imarika Chamaa work?",
    href: "#",
    description: <HowImarikaChamaa />,
    category: { title: "Imarika Chamaa", href: "#" },
  },
  {
    id: 2,
    title: "Why should you invest through Imarika Chama?",
    href: "#",
    description: <WhyImarikaChamaa />,
    category: { title: "Imarika Chamaa", href: "#" },
  },
  {
    id: 2,
    title: "Who should sign up for Imarika Chama?",
    href: "#",
    description: <WhoImarikaChamaa />,
    category: { title: "Imarika Chamaa", href: "#" },
  },
  // More posts...
];

export default function ImarikaChama() {
  return (
    <div className="bg-white py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto  lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
            Imarika Chamaa Investment Plan
          </h2>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            Imarika Chamaa Investment Plan, is a medium term goal-driven
            investment solution designed for Chamaas and Groups that provides an
            opportunity to organize contributions towards a specific investment
            goal while benefiting from superior returns, flexibility,
            affordability and free Life Insurance cover for every member.{" "}
          </p>
          <p className="mt-2 text-lg leading-8 text-gray-600">
            The plan enables the group members to plan together and work towards
            their intended goal in a structured way, whether the goal is to
            purchase tracks of land, put up real estate property or simply to
            diversify your investment options.{" "}
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article
              key={post.id}
              className="flex max-w-xl  items-start justify-between"
            >
              <div className="flex items-center gap-x-4 text-xs">
              
              </div>
              <div className="group relative">
                <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                  <a href={post.href}>
                    <span className="absolute inset-0" />
                    {post.title}
                  </a>
                </h3>
                <p className="mt-5  text-sm leading-6 text-gray-600">
                  {post.description}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  );
}
